import { render, staticRenderFns } from "./AppSidebar.vue?vue&type=template&id=34ce02fb&"
import script from "./AppSidebar.vue?vue&type=script&lang=ts&"
export * from "./AppSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./AppSidebar.vue?vue&type=style&index=0&id=34ce02fb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./AppSidebar.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports